import { action } from 'typesafe-actions';
import { StudentUserActionTypes } from './types';
import { IUser, IUsersListFromAPI } from '../../types';

export const getStudentUserRecord = (studentId: string, studentEmail: string, pathway?: string) =>
  action(StudentUserActionTypes.GET_STUDENT_USER, { studentId, studentEmail, pathway });
export const getStudentUserRecordSuccess = (users: IUsersListFromAPI) =>
  action(StudentUserActionTypes.GET_STUDENT_USER_SUCCESS, users);
export const getStudentUserRecordFailure = (error: string) =>
  action(StudentUserActionTypes.GET_STUDENT_USER_FAILURE, error);

export const resetPassword = (uniId: string, username: string, pathway?: string) =>
  action(StudentUserActionTypes.RESET_USER, {
    uniId,
    username,
    pathway,
  });

export const resetPasswordSuccess = (username: string) =>
  action(StudentUserActionTypes.RESET_USER_SUCCESS, { username });
export const resetPasswordFailure = (error: string) => action(StudentUserActionTypes.RESET_USER_FAILURE, error);

export const reinviteUser = (uniId: string, username: string, pathway?: string) =>
  action(StudentUserActionTypes.REINVITE_USER, {
    uniId,
    username,
    pathway,
  });

export const reinviteUserSuccess = (username: string) =>
  action(StudentUserActionTypes.REINVITE_USER_SUCCESS, { username });
export const reinviteUserFailure = (error: string) => action(StudentUserActionTypes.REINVITE_USER_FAILURE, error);

export const resetStudentMfaRequest = (user: IUser) => action(StudentUserActionTypes.RESET_STUDENT_MFA_REQUEST, user);
export const resetStudentMfaSuccess = (user: IUser) => action(StudentUserActionTypes.RESET_STUDENT_MFA_SUCCESS, user);
export const resetStudentMfaFailure = (message: string) =>
  action(StudentUserActionTypes.RESET_STUDENT_MFA_FAILURE, { message });
